import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FilterShowMoreItem } from '@atlassian/search-dialog';
import Avatar from '@atlaskit/avatar';
export const FilterOptionItem = ({
  label,
  iconProps
}) => {
  return /*#__PURE__*/React.createElement(FilterShowMoreItem, {
    icon: /*#__PURE__*/React.createElement(Avatar, _extends({
      name: label,
      size: 'small'
    }, iconProps)),
    label: label
  });
};